import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

var getClassNames = function getClassNames(_ref) {
  var _classNames;

  var status = _ref.status,
      dot = _ref.dot,
      className = _ref.className;
  return classNames('roo-badge', 'roo-badge-fixed', (_classNames = {}, _defineProperty(_classNames, "roo-badge-".concat(status), status), _defineProperty(_classNames, 'roo-badge-dot', dot), _classNames), className);
};

var formatContent = function formatContent(note) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99;

  if (typeof note === 'number') {
    return note > max ? "".concat(max, "+") : note;
  }

  return note;
};

var Badge = function Badge(props) {
  var note = props.note,
      children = props.children,
      style = props.style,
      dot = props.dot,
      max = props.max;
  var content = formatContent(note, max);
  return /*#__PURE__*/React.createElement("span", {
    className: "roo-badge-wrap"
  }, children, /*#__PURE__*/React.createElement("sup", {
    style: style,
    className: getClassNames(props)
  }, dot ? null : content));
};

Badge.propTypes = {
  note: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  // eslint-disable-next-line
  status: PropTypes.oneOf(['default', 'info', 'success', 'danger', 'warning']),
  dot: PropTypes.bool,
  max: PropTypes.number
};
Badge.defaultProps = {
  note: undefined,
  status: 'danger',
  dot: false,
  max: 99
};
export default Badge;